<template>
  <v-card>
    <v-card-title class="subheading">
      <div>
        <v-btn icon flat>
          <v-icon v-if="opened" @click="opened = false">keyboard_arrow_down</v-icon>
          <v-icon v-else @click="opened = true">keyboard_arrow_right</v-icon>
        </v-btn>
      </div>
      <div>{{ item.title }}</div>
    </v-card-title>
    <v-card-text v-if="opened">
      <div v-html="item.content"></div>
    </v-card-text>
    <v-card-text v-if="opened">
      <DropZone v-model="files" :edit-mode="false" :type="'files'"></DropZone>
    </v-card-text>
    <v-card-actions class="justify-end" v-if="opened">
      <v-btn @click="$emit('edit')">Editer</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import DropZone from "../commons/DropZone";
import {fetchHil} from "../../utils";
export default {
  name: "Kbitem",
  components: {DropZone},
  props: ["item"],
  data() {
    return {
      opened: false,
      files: []
    };
  },
  mounted() {
    this.refreshDocs();
  },
  methods: {
    async refreshDocs() {
      const resp = await fetchHil(`/cache/for/${this.item._id}`);
      this.files = await resp.json();
    },
  }
};
</script>

<style scoped></style>
